// extracted by mini-css-extract-plugin
export var aboveInput = "_m7-0";
export var actionButton = "_m7-5";
export var actionButtonContainer = "_m7-1";
export var actionIcon = "_m7-6";
export var aiInfoContainer = "_m7-2";
export var attachmentWrapper = "_m7-7";
export var bold = "_m7-3";
export var checkIcon = "_m7-8";
export var clickingRecipientBar = "_m7-11";
export var commentThreadSwitch = "_m7-a";
export var draftImage = "_m7-b";
export var draftImageContainer = "_m7-c";
export var draftImages = "_m7-e";
export var editButton = "_m7-g";
export var editor = "_m7-f";
export var editorContainer = "_m7-y";
export var editorErrorTooltipWrapper = "_m7-9";
export var headerDivider = "_m7-h";
export var icon = "_m7-i";
export var info = "_m7-j";
export var internal = "_m7-n";
export var internalDivider = "_m7-k";
export var internalMessage = "_m7-l";
export var messageInputCard = "_m7-m";
export var messageInputForm = "_m7-o";
export var messageInputFormInternal = "_m7-p";
export var options = "_m7-q";
export var publicMessageCustomer = "_m7-s";
export var publicMessageMerchant = "_m7-r";
export var removeImageButton = "_m7-d";
export var replyButtons = "_m7-t";
export var showSignatureButton = "_m7-u";
export var spinner = "_m7-v";
export var verticalButtonDivider = "_m7-4";
export var visibilitySelector = "_m7-w";
export var warning = "_m7-x";
export var wrappingText = "_m7-z";
export var writingInternalNoteTopBorder = "_m7-10";